/**
 * An array of chart options which are used in creating new charts
 */
const options = [{
	optionType: 'charts.basicCharts',
	options: [{
		type: 'blank',
		label: 'charts.blank',
		icon: 'layout-blank'
	},{
		type: 'bar',
		label: 'charts.bar'
	},{
		type: 'line',
		label: 'charts.line'
	},{
		type: 'area',
		label: 'charts.area'
	},{
		type: 'pie',
		label: 'charts.pie'
	},{
		type: 'donut',
		label: 'charts.donut'
	},{
		type: 'polar',
		label: 'charts.polar'
	}]
},{
	optionType: 'charts.scorecardItemCharts',
	options: [{
		type: 'scorecard-line',
		label: 'charts.scorecardLine'
	},{
		type: 'scorecard-light-bands',
		label: 'charts.scorecardLightBands'
	},{
		type: 'scorecard-dark-bands',
		label: 'charts.scorecardDarkBands'
	}]
},{
	optionType: 'charts.advancedCharts',
	options: [{
		type: 'multiple-lines',
		label: 'charts.multipleLines'
	},{
		type: 'dual-axis',
		label: 'charts.dualAxis'
	},{
		type: 'multiple-bar',
		label: 'charts.multipleBar'
	},{
		type: 'stacked-bar',
		label: 'charts.stackedBar'
	},{
		type: 'stacked-100-bar',
		label: 'charts.stacked100Bar'
	},{
		type: 'stacked-multiple-bar',
		label: 'charts.stackedMultipleBar'
	},{
		type: 'stacked-area',
		label: 'charts.stackedArea'
	}]
},{
	optionType: 'charts.combinationCharts',
	options: [{
		type: 'line-and-bar',
		label: 'charts.lineAndBar'
	},{
		type: 'line-and-multiple-bar',
		label: 'charts.lineAndMultipleBar'
	},{
		type: 'line-and-stacked-bar',
		label: 'charts.lineAndStackedBar'
	},{
		type: 'line-and-area',
		label: 'charts.lineAndArea'
	},{
		type: 'line-and-stacked-area',
		label: 'charts.lineAndStackedArea'
	}]
},{
// TODO: Not in initial release
// 	optionType: 'charts.statisticalCharts',
// 	options: [{
// 		type: 'pareto',
// 		label: 'charts.pareto',
// 		disabled
// 	},{
// 		type: 'control',
// 		label: 'charts.control',
// 		disabled
// 	}]
// },{
	optionType: 'charts.analyticCharts',
	options: [{
		type: 'trend-line',
		label: 'charts.feature.trend-line'
	},{
		type: 'forecast',
		label: 'charts.forecast'
	}]
},{
 	optionType: 'charts.geospacial',
 	options: [{
 		type: 'filled-map',
 		label: 'charts.chart.plotType.filledMap'
// 	},{
// 		type: 'bubble-map',
// 		label: 'charts.chart.plotType.bubbleMap',
// 		disabled
// 	},{
// 		type: 'filled-globe',
// 		label: 'charts.filledGlobe',
// 		disabled
// 	},{
// 		type: 'bubble-globe',
// 		label: 'charts.bubbleGlobe',
// 		disabled
 	}]
},{
	optionType: 'charts.diagrams',
	options: [{
		type: 'process',
		label: 'charts.process'
	},{
		type: 'cycle',
		label: 'charts.cycle'
	},{
		type: 'timeline',
		label: 'charts.timeline'
	},{
		type: 'funnel',
		label: 'charts.funnel'
	},{
		type: 'pyramid',
		label: 'charts.pyramid'
	},{
		type: 'tree-map',
		label: 'charts.chart.plotType.treeMap'
	},{
		type: 'waffle',
		label: 'charts.waffle'
	},{
		type: 'filled-container',
		label: 'charts.filledContainer'
	}]
}]

// #37630 The icon naming convention for these is ${type}-chart, so add a separate
// icon property that can be used in templates
options.forEach(group => group.options.forEach(o => o.icon = o.icon || o.type + '-chart'))
export default options
options.__filename__ = 'charts/chart-types.js'
